const BASE_API =  process.env.MIX_ENDLESS_API_URL

const state = {
	catalogAssociatedCountries:[],
	catalogAssociatedPrograms:[],
}
const getters = {
	catalogAssociatedCountriesGetter:({catalogAssociatedCountries}) => catalogAssociatedCountries,
	catalogAssociatedProgramsGetter:({catalogAssociatedPrograms}) => catalogAssociatedPrograms,
}
const mutations = {
	setCatalogAssociatedCountries: (state,payload)=> state.catalogAssociatedCountries = payload,
	setCatalogAssociatedPrograms: (state,payload)=> state.catalogAssociatedPrograms = payload,
}
const actions = {
	async getCatalogAssociatedCountries({commit}, payload){
		const params = {
			filters: 'has_catalog:true;is_country:true;page_limit:250;country_only:true;is_except_school_type:true',
			...payload
		}
		await this.$axios.get(`${BASE_API}/places`, {params}).then(res => {
			commit('setCatalogAssociatedCountries',res.data.result.data)
		})
	},
	async getCatalogAssociatedPrograms({commit}, payload){
		const params = {
			filters: 'has_catalog:true',
			...payload
		}
		await this.$axios.get(`${BASE_API}/course-types`, {params}).then(res => {
			commit('setCatalogAssociatedPrograms',res.data.result.data)
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
